export const formatCpfToSpecialChars = (cpf: string): string => {
  const cpfFormatted = cpf
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  return cpfFormatted;
};
